// extracted by mini-css-extract-plugin
export default {"bg":"emailVerification_bg__MnNgJ","spinButtonNone":"emailVerification_spinButtonNone__egi+Z","btn":"emailVerification_btn__4+D8u"};